import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';
import { NAPLO_OPCIOK } from '../naplo.opciok';
import { torzsadatMezok, torzsadatTablak, TorzsMezo, TorzsTabla, torzsForrasNev } from '../nav-torzsadat-mezok';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

@Component({
  selector: 'app-naplo-torzsek',
  templateUrl: './torzsek.component.html',
  styleUrls: ['../naplo-shared.scss', './torzsek.component.scss'],
})
export class TorzsekComponent implements OnInit, OnDestroy {
  @ViewChild('rovatModal') rovatModal: IonModal;
  @ViewChild('partnerModal') partnerModal: IonModal;
  @ViewChild('gyujtoModal') gyujtoModal: IonModal;
  @ViewChild('penztarModal') penztarModal: IonModal;
  @ViewChild('oszlopModal') oszlopModal: IonModal;

  opciok = NAPLO_OPCIOK;
  nezet: 'rovat' | 'partner' | 'gyujto' | 'penztar' | 'oszlop' | 'osa' | 'navtorzs' | 'bevsor' | 'adokod' | 'munkaszam' = 'rovat';
  osa: any = { login: '', adoszam: '', sandbox: false, kep_auto: false, jelszo: '', signkey: '', exchangekey: '' };
  /*  NAV technikai felhasználó KÉT környezetben (teszt/éles), váltással: amelyik aktív, azzal megy
   *  minden gépi kapcsolat (Online Számla, pénztárgép, NAV törzsadat, eÁFA). */
  readonly techKornyezetek: ('teszt' | 'eles')[] = ['teszt', 'eles'];
  tech: any = null;
  techUrlap: Record<string, any> = { teszt: {}, eles: {} };
  techFut: string | null = null;
  osaAllapot: any = null;
  /*  Az eÁFA NEM kap külön hitelesítőt: ugyanezzel a technikai felhasználóval megy, és a
   *  „teszt (sandbox)" jelölés dönti el, melyik NAV-világba. Itt csak az állapota és a próbája van. */
  eafaKapcs: any = null;
  eafaFut: string | null = null;
  osaTeszteles = false;
  /*  Számlázóprogram (Billingo / Számlázz.hu) – CSAK a kimenő számlák képéhez. A kulcsot sosem
   *  kapjuk vissza a kiszolgálótól; üresen hagyva a mentett marad. */
  szamlazo: any = null;
  szamlazoUrlap: Record<string, { kulcs: string; aktiv: boolean }> = {};
  szamlazoFut: string | null = null;
  szamlazoProbaSzam = '';
  get szamlazoVanAktiv(): boolean { return !!this.szamlazo?.kapcsolatok?.some((k: any) => k.van_kulcs && k.aktiv); }
  // NAV törzsadat. Forrás: 'upo' (alap – a NAV Ügyfélportál HITELESÍTETT PDF-jéből kiolvasva,
  // Ügyfélkapuval) | 'osa' (queryTaxpayer részhalmaz, technikai felhasználóval).
  navtorzs: any = null;                 // az ÉPPEN megjelenített lekérés adata (alapból a legfrissebb)
  torzsForrasNev = torzsForrasNev;   // template-ből hívható
  navtorzsMeta: any = { konfiguralt: false, utolso_szinkron: null, forras: 'upo', van_ugyfelkapu: false, van_osa: false };
  navtorzsHistory: any[] = [];          // összes lekérés (legfrissebb elöl)
  navtorzsAktivId: string | null = null; // az éppen megjelenített lekérés id-ja
  navtorzsBetolt = false;

  /*  A NAV-törzsadat (navtorzs) objektumához kötve tárolva (2026-11-05): a getter minden változásészleléskor új
   *  mező- és táblalistát adott, az *ngFor ezért mindet újraépítette. Csak a navtorzs cseréjekor számol újra. */
  private torzsTar: { n: any; mezok: TorzsMezo[]; tablak: TorzsTabla[] } | null = null;
  private torzsKesz() {
    if (!this.torzsTar || this.torzsTar.n !== this.navtorzs) {
      this.torzsTar = { n: this.navtorzs, mezok: torzsadatMezok(this.navtorzs), tablak: torzsadatTablak(this.navtorzs) };
    }
    return this.torzsTar;
  }
  get torzsMezok(): TorzsMezo[] { return this.torzsKesz().mezok; }
  get torzsTablak(): TorzsTabla[] { return this.torzsKesz().tablak; }
  rovatok: any[] = [];
  partnerek: any[] = [];
  gyujtok: any[] = [];
  penztarak: any[] = [];
  oszlopok: any[] = [];
  szerk: any = null;
  /*  SZERKESZTÉSI ZÁR (backend/szerkesztes-zar.js) a szerkesztőablakban nyitott rovatra / partnerre /
   *  gyűjtőre / pénztárra – egyszerre egy ablak nyílik (a `szerk` is közös), ezért egy fogantyú. Az
   *  ablak eltűnésekor (didDismiss) elenged. Az oszlopot a kiszolgáló nem védi. */
  zar: SzerkZar | null = null;
  private zarKor = 0;
  /** Zár kérése; ha a válasz megérkezéséig az ablak már mást mutat (vagy bezárult), a késő zárat elengedjük. */
  private async zarKer(tipus: string, id: any, ujratolt: () => unknown) {
    this.zarEngedd();
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('naplo', tipus, id, { ujratolt });
    if (kor !== this.zarKor) { z?.felenged(); return; }
    this.zar = z;
  }
  zarEngedd() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  /** Más szerkeszti – nálunk nem menthető. */
  get zarTilt() { return !!this.zar && !this.zar.irhato; }
  /** A zár felszabadulásakor / „Újratöltés”-re: friss lista, és ha az ablak még ezt mutatja, friss rekord. */
  private async szerkUjratolt(kind: 'rovat' | 'partner' | 'gyujto' | 'penztar', id: string, alak: (x: any) => any) {
    await this.valt(kind);
    const lista: any[] = ({ rovat: this.rovatok, partner: this.partnerek, gyujto: this.gyujtok, penztar: this.penztarak })[kind] || [];
    const x = lista.find((y: any) => y.id === id);
    if (x && this.szerk?.id === id) this.szerk = alak(x);
  }

  /*  EU-ADÓSZÁM ELLENŐRZÉS (VIES, díjmentes) a partnernél. Üres közösségi adószámnál a magyar
   *  adószámból képzi; érvényes találatnál az üres mezőket (közösségi adószám, név) kitölti. */
  vies: any = null;
  viesFut = false;
  async partnerVies() {
    const szam = String(this.szerk?.kozossegi_adoszam || this.szerk?.adoszam || '').trim();
    if (!szam) return;
    this.viesFut = true; this.vies = null;
    try {
      this.vies = await this.naplo.get('/vies/' + encodeURIComponent(szam));
      if (this.vies?.ok && this.vies.ervenyes) {
        if (!this.szerk.kozossegi_adoszam) this.szerk.kozossegi_adoszam = this.vies.szam;
        if (!String(this.szerk.nev || '').trim() && this.vies.nev) this.szerk.nev = this.vies.nev;
        if (!this.szerk.orszagkod) this.szerk.orszagkod = String(this.vies.szam).slice(0, 2).replace('EL', 'GR');
      }
    } catch { this.vies = { ok: false, hiba: 'A VIES szolgáltatás most nem érhető el.' }; }
    finally { this.viesFut = false; }
  }
  constructor(private naplo: NaploService, private toast: ToastController, private alert: AlertController, private router: Router,
              private route: ActivatedRoute, private szerkZar: SzerkZarService) {}

  get aktiv() { return this.naplo.aktiv; }

  /*  A nézetet a főmenü választja ki (`?nezet=partner` …) – a régi belső fül-sáv helyett. A
   *  kettős könyvelésű ügyfél törzsadatai a kettős nézetben élnek (számlatükör, beállítások). */
  static readonly CIMEK: Record<string, string> = {
    rovat: 'Rovatok', oszlop: 'Oszlopok', partner: 'Partnertörzs', gyujto: 'Gyűjtők',
    penztar: 'Pénztár és bank', osa: 'NAV technikai felhasználó (OSA / OPG)', navtorzs: 'NAV törzsadat', bevsor: 'ÁFA-bevallási sorok',
    adokod: 'Adókódok', munkaszam: 'Munkaszámok',
  };
  static readonly KOZOS = new Set(['partner', 'osa', 'navtorzs', 'bevsor', 'adokod', 'munkaszam']);
  get nezetCim() { return TorzsekComponent.CIMEK[this.nezet] || 'Törzsadatok'; }
  private qSub?: Subscription;

  async ngOnInit() {
    await this.naplo.init();
    this.qSub = this.route.queryParamMap.subscribe(async (q) => {
      const n = (q.get('nezet') || 'rovat') as any;
      // KÖZÖS képernyők a két könyvelési módban: partnertörzs, NAV-kulcsok (OSA/OPG), NAV
      // törzsadat. A többi törzs (rovat, oszlop, pénztár, gyűjtő) egyszeres-specifikus – kettősnél
      // helyette a számlatükör nyílik.
      if (this.aktiv.konyveles_mod === 'kettos' && !TorzsekComponent.KOZOS.has(n)) {
        this.router.navigate(['/naplo/kettos'], { queryParams: { nezet: 'tukor' }, replaceUrl: true });
        return;
      }
      if (this.aktiv.ugyfelId) await this.valt(TorzsekComponent.CIMEK[n] ? n : 'rovat');
    });
  }
  ngOnDestroy() { this.qSub?.unsubscribe(); this.zarEngedd(); }

  /* ── ÁFA-bevallási sorok törzse (közös, minden ügyfélre; a számlasor ebből választ) ── */
  bevsorok: any[] = [];
  bevsorKereso = '';
  get bevsorLathato(): any[] {
    const k = this.bevsorKereso.trim().toLowerCase();
    return k ? this.bevsorok.filter((b) => !b.id || String(b.kod).toLowerCase().startsWith(k) || String(b.nev).toLowerCase().includes(k)) : this.bevsorok;
  }
  async bevsorBetolt() {
    this.bevsorok = (await this.naplo.getAbs<any[]>('/api/naplo-naplok/bevallas-sorok?mind=1')).map((b) => ({ ...b, aktiv: !!b.aktiv, _v: false }));
  }
  bevsorUj() { this.bevsorok.unshift({ id: null, kod: '', nev: '', irany: 'fizetendo', aktiv: true, sorrend: 0, _v: true }); }
  async bevsorMent(b: any) {
    try {
      await this.naplo.postAbs('/api/naplo-naplok/bevallas-sor', b);
      this.ok('Bevallási sor mentve.');
      await this.bevsorBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  /*  A 65-ös bevallás sorai az eÁFA adókód-katalógusából: minden sor, amire egy kód mutat, bekerül.
   *  (Az ÁNYK megszűnik – a sorokat az eÁFA-ban a NAV adókódjai jelölik ki.) A meglévő megnevezések maradnak. */
  async bevsorNavbol() {
    try {
      const r: any = await this.naplo.postAbs('/api/nav-adokod/bevallas-sorok', {});
      await this.bevsorBetolt();
      this.ok(r?.felvett?.length ? `${r.felvett.length} új sor felvéve (${r.felvett.join(', ')}); ${r.meglevo} már megvolt.`
        : `Mind a ${r?.hivatkozott || 0} sor, amire a NAV adókódjai mutatnak, már a törzsben van.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült frissíteni.'); }
  }
  async bevsorTorol(b: any) {
    if (!b.id) { this.bevsorok = this.bevsorok.filter((x) => x !== b); return; }
    const a = await this.alert.create({ header: 'Törlés', message: `Törlöd a(z) ${b.kod} bevallási sort a törzsből? (A már könyvelt tételeken a kód megmarad.)`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
        try { await this.naplo.delAbs('/api/naplo-naplok/bevallas-sor/' + b.id); await this.bevsorBetolt(); } catch { this.hiba('Nem sikerült törölni.'); }
      } }] });
    a.present();
  }

  /* ── ADÓKÓD: a NAV SZABVÁNYOS ADÓKÓD-KATALÓGUSA (eÁFA) ──
   *  Közös, rögzített lista (a NAV szerint az eÁFA-ban csak az aktuális kódok szerepelhetnek),
   *  ezért itt nem szerkeszthető – a NAV nyilvános eVAT tárhelyéről frissül. */
  adokodok: any[] = [];
  adokodKereso = '';
  adokodKatalogus = '';
  adokodFrissul = false;
  get adokodLathato(): any[] {
    const k = this.adokodKereso.trim().toLowerCase(), kt = k.replace(/\s+/g, '');
    return k ? this.adokodok.filter((a) => String(a.kod).toLowerCase().replace(/\s+/g, '').includes(kt)
      || String(a.beszedes || '').toLowerCase().replace(/\s+/g, '').includes(kt) || String(a.leiras || '').toLowerCase().includes(k)) : this.adokodok;
  }
  async adokodBetolt() {
    this.adokodok = await this.naplo.getAbs<any[]>('/api/nav-adokod').catch(() => []);
    this.adokodKatalogus = this.adokodok.find((a) => a.katalogus)?.katalogus || '';
  }
  adokodSorok(a: any): string {
    const f = [a.mp1, a.mp2].filter(Boolean).join(', '), r = [a.dp1, a.dp2, a.dp3].filter(Boolean).join(', ');
    const l = a.md, d = [a.dd1, a.dd2, a.dd3, a.dh1, a.dh2].filter(Boolean).join(', ');
    return [f && `fizetendő ${f}`, r && `részletező ${r}`, l && `levonható ${l}`, d && `kiemelő ${d}`, a.pg && `${a.pg}. lap`].filter(Boolean).join(' · ');
  }
  async adokodFrissit() {
    this.adokodFrissul = true;
    try {
      const r: any = await this.naplo.postAbs('/api/nav-adokod/nav-frissites', {});
      await this.adokodBetolt();
      this.ok(`NAV-katalógus (${r?.katalogus}): ${r?.osszes} kód, ebből ${r?.uj || 0} új${r?.kivezetett ? `, ${r.kivezetett} kivezetett` : ''}.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült letölteni a NAV katalógusát.'); }
    finally { this.adokodFrissul = false; }
  }

  /* ── Munkaszámok (kettős; ügyfelenként). Kód legfeljebb 10, név legfeljebb 30 karakter – mint az RLB-ben. ── */
  munkaszamok: any[] = [];
  async munkaszamBetolt() {
    this.munkaszamok = (await this.naplo.getAbs<any[]>('/api/kettos/munkaszamok/' + this.aktiv.ugyfelId).catch(() => []))
      .map((m: any) => ({ ...m, _v: false }));
  }
  munkaszamUj() { this.munkaszamok.unshift({ id: null, kod: '', nev: '', _v: true }); }
  async munkaszamMent(m: any) {
    try {
      await this.naplo.postAbs('/api/kettos/munkaszam/' + this.aktiv.ugyfelId, { kod: m.kod, nev: m.nev });
      this.ok('Munkaszám mentve.');
      await this.munkaszamBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async munkaszamTorol(m: any) {
    if (!m.id) { this.munkaszamok = this.munkaszamok.filter((x) => x !== m); return; }
    try { await this.naplo.delAbs('/api/kettos/munkaszam/' + m.id); await this.munkaszamBetolt(); } catch { this.hiba('Nem sikerült törölni.'); }
  }

  async valt(n: any) {
    this.nezet = n;
    const id = this.aktiv.ugyfelId;
    try {
      if (n === 'adokod') await this.adokodBetolt();
      if (n === 'munkaszam') await this.munkaszamBetolt();
      if (n === 'rovat') this.rovatok = await this.naplo.get('/rovatok/' + id);
      if (n === 'partner') this.partnerek = await this.naplo.get('/partnerek/' + id);
      if (n === 'gyujto') this.gyujtok = await this.naplo.get('/gyujtok/' + id);
      if (n === 'penztar') this.penztarak = await this.naplo.get('/penztarak/' + id);
      if (n === 'oszlop') this.oszlopok = await this.naplo.get('/oszlopok/' + id + this.naplo.evq());
      if (n === 'bevsor') await this.bevsorBetolt();
      if (n === 'osa') {
        this.osaAllapot = await this.naplo.get('/osa/beallitas/' + id);
        this.osa = { login: this.osaAllapot.login || '', adoszam: this.osaAllapot.adoszam || '', sandbox: !!this.osaAllapot.sandbox,
          kep_auto: !!this.osaAllapot.kep_auto, jelszo: '', signkey: '', exchangekey: '' };
        await this.techBetolt();
        await this.eafaKapcsBetolt();
        await this.szamlazoBetolt();
      }
      if (n === 'navtorzs') await this.betoltNavTorzs();
    } catch { this.hiba('Nem sikerült betölteni.'); }
  }

  // ---- NAV törzsadat ----
  // Az aktuális (legfrissebb) lekérés + a teljes history betöltése. Az aktuálisat mutatjuk.
  async betoltNavTorzs() {
    const r: any = await this.naplo.get('/nav-torzsadat/' + this.aktiv.ugyfelId);
    this.navtorzsMeta = { konfiguralt: r.konfiguralt, utolso_szinkron: r.utolso_szinkron, forras: r.forras || 'upo',
      van_ugyfelkapu: !!r.van_ugyfelkapu, van_osa: !!r.van_osa };
    this.navtorzsHistory = r.history || [];
    this.navtorzs = r.torzs;
    this.navtorzsAktivId = r.aktualis_id || (this.navtorzsHistory[0]?.id ?? null);
  }

  // Törzsadat-forrás váltása (eBEV = hivatalos, gazdag | OSA = API-részhalmaz).
  async valtTorzsForras(forras: string) {
    if (!forras || forras === this.navtorzsMeta.forras) return;
    try {
      await this.naplo.put('/nav-torzsadat/beallitas/' + this.aktiv.ugyfelId, { forras });
      await this.betoltNavTorzs();
      this.ok('Törzsadat-forrás: ' + this.torzsForrasNev(forras));
    } catch (e: any) { this.hiba(e?.error?.error || 'A forrás váltása nem sikerült.'); }
  }

  // Friss lekérdezés a NAV-tól (queryTaxpayer) az ügyfél saját adószámára; az OSA technikai
  // felhasználóval megy (az „OSA / NAV" fülön beállítva). MINDEN lekérés history-ba kerül; a
  // frissítés után a legfrissebbet mutatjuk. Időzítve is fut (Szinkronizálás fül).
  async frissitNavTorzs() {
    if (!this.aktiv.ugyfelId) return;
    this.navtorzsBetolt = true;
    try {
      const r: any = await this.naplo.post('/nav-torzsadat/szinkron/' + this.aktiv.ugyfelId, {});
      this.navtorzs = r.torzs;
      this.navtorzsMeta.utolso_szinkron = r.utolso_szinkron;
      this.navtorzsHistory = r.history || this.navtorzsHistory;
      this.navtorzsAktivId = r.aktualis_id || (this.navtorzsHistory[0]?.id ?? null);
      this.ok('NAV törzsadat frissítve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'A NAV törzsadat-lekérdezés nem sikerült.'); }
    finally { this.navtorzsBetolt = false; }
  }

  // Visszalépés egy korábbi lekérésre (a history-választóból).
  async valasztTorzsVerzio(id: string) {
    if (!id) return;
    this.navtorzsAktivId = id;
    try {
      const r: any = await this.naplo.get('/nav-torzsadat/' + this.aktiv.ugyfelId + '/tetel/' + id);
      this.navtorzs = r.torzs;
    } catch (e: any) { this.hiba(e?.error?.error || 'A lekérés betöltése nem sikerült.'); }
  }

  // Az éppen megjelenített lekérés a legfrissebb-e?
  get navtorzsLegfrissebb(): boolean {
    return !this.navtorzsHistory.length || this.navtorzsAktivId === this.navtorzsHistory[0].id;
  }

  // A megjelenített lekérés PDF-jének letöltése (bináris blob, token-nel).
  async letoltNavTorzsPdf() {
    if (!this.navtorzsAktivId) return;
    try {
      const blob = await this.naplo.getBlob('/nav-torzsadat/pdf/' + this.navtorzsAktivId);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'nav_torzsadat_' + (this.navtorzs?.adoszam || '').replace(/\D/g, '') + '.pdf';
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 1500);
    } catch { this.hiba('A PDF letöltése nem sikerült.'); }
  }

  navtorzsTipusCimke(t: string): string {
    return t === 'ceg' ? 'Cég / szervezet' : (t === 'egyeni' ? 'Egyéni vállalkozó' : (t === 'maganszemely' ? 'Adószámos magánszemély' : (t || '—')));
  }
  navtorzsCimTipus(t: string): string {
    const u = String(t || '').toUpperCase();
    return u === 'HQ' ? 'Székhely' : (u === 'SITE' ? 'Telephely' : (u === 'BRANCH' ? 'Fióktelep' : (t || 'Cím')));
  }

  // ---- OSA / NAV beállítások ----
  /* ── NAV technikai felhasználó: teszt/éles tárolás és váltás ── */
  async techBetolt() {
    try {
      this.tech = await this.naplo.get('/nav-tech/' + this.aktiv.ugyfelId);
      this.techUrlap = { teszt: {}, eles: {} };
    } catch { this.tech = null; }
  }
  async techMent(k: 'teszt' | 'eles') {
    this.techFut = 'ment-' + k;
    try {
      await this.naplo.put('/nav-tech/' + this.aktiv.ugyfelId, { kornyezet: k, ...this.techUrlap[k] });
      await this.techBetolt(); await this.valt('osa'); await this.eafaKapcsBetolt();
      this.ok((k === 'teszt' ? 'Teszt' : 'Éles') + ' technikai felhasználó mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
    finally { this.techFut = null; }
  }
  async techValt(k: 'teszt' | 'eles') {
    this.techFut = 'valt';
    try {
      await this.naplo.post('/nav-tech/' + this.aktiv.ugyfelId + '/valt', { kornyezet: k });
      await this.techBetolt(); await this.valt('osa'); await this.eafaKapcsBetolt();
      this.ok(k === 'teszt' ? 'A teszt technikai felhasználó az aktív – minden lekérés a NAV tesztrendszerébe megy.'
        : 'Az éles technikai felhasználó az aktív.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült váltani.'); }
    finally { this.techFut = null; }
  }
  async kepAutoMent(be: boolean) {
    try { await this.naplo.put('/nav-tech/' + this.aktiv.ugyfelId, { kornyezet: this.tech?.aktiv || 'eles', kep_auto: !!be }); this.ok(be ? 'Számlaképek letöltése bekapcsolva.' : 'Számlaképek letöltése kikapcsolva.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  /* ── Számlázóprogram (Billingo / Számlázz.hu): a kimenő számlák képe az ügyfél saját kulcsával ── */
  async szamlazoBetolt() {
    try {
      this.szamlazo = await this.naplo.get('/szamlazo/' + this.aktiv.ugyfelId);
      this.szamlazoUrlap = {};
      for (const k of this.szamlazo.kapcsolatok || []) this.szamlazoUrlap[k.szolgaltato] = { kulcs: '', aktiv: k.van_kulcs ? k.aktiv : true };
    } catch { this.szamlazo = null; }
  }
  async szamlazoMent(k: any) {
    const u = this.szamlazoUrlap[k.szolgaltato];
    this.szamlazoFut = 'ment-' + k.szolgaltato;
    try {
      await this.naplo.put(`/szamlazo/${this.aktiv.ugyfelId}/${k.szolgaltato}`, { kulcs: u.kulcs.trim(), aktiv: u.aktiv });
      const ujKulcs = !!u.kulcs.trim();
      await this.szamlazoBetolt();
      this.ok(`${k.nev}: mentve.`);
      if (ujKulcs) await this.szamlazoProba(k);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
    finally { this.szamlazoFut = null; }
  }
  async szamlazoProba(k: any) {
    this.szamlazoFut = 'proba-' + k.szolgaltato;
    try {
      const r: any = await this.naplo.post(`/szamlazo/${this.aktiv.ugyfelId}/${k.szolgaltato}/proba`,
        { szamlaszam: k.szolgaltato === 'szamlazz' ? this.szamlazoProbaSzam.trim() : '' });
      r?.ok ? this.ok(r.uzenet || 'A kapcsolat rendben.') : this.hiba(r?.uzenet || 'Sikertelen kapcsolat.');
      await this.szamlazoBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'Sikertelen kapcsolat.'); }
    finally { this.szamlazoFut = null; }
  }
  async szamlazoTorol(k: any) {
    const a = await this.alert.create({
      header: `${k.nev} kapcsolat törlése`, message: 'A mentett kulcs törlődik. A már letöltött számlaképek megmaradnak.',
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
        try { await this.naplo.del(`/szamlazo/${this.aktiv.ugyfelId}/${k.szolgaltato}`); await this.szamlazoBetolt(); this.ok('Törölve.'); }
        catch { this.hiba('Nem sikerült törölni.'); }
      } }],
    });
    await a.present();
  }
  async szamlazoLetolt(kenyszer = false) {
    this.szamlazoFut = 'letolt';
    try {
      const r: any = await this.naplo.post(`/szamlazo/${this.aktiv.ugyfelId}/letoltes`, { kenyszer });
      this.ok(r?.mar_futott ? 'A letöltés már fut – a fejléc jelzőjén követhető.' : 'A letöltés elindult – a fejléc jelzőjén követhető.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült elindítani.'); }
    finally { this.szamlazoFut = null; }
  }

  /* ── eÁFA-kapcsolat: ugyanez a technikai felhasználó, a sandbox jelölés szerinti környezetben ── */
  async eafaKapcsBetolt() {
    try { this.eafaKapcs = await this.naplo.getAbs('/api/naplo-eafa/kapcsolat/' + this.aktiv.ugyfelId); }
    catch { this.eafaKapcs = null; }
  }
  /** Ártalmatlan lekérdezés (adókód-katalógus): elfogadja-e a NAV a hitelesítőt. */
  async eafaProba() {
    this.eafaFut = 'proba';
    try {
      const r: any = await this.naplo.postAbs('/api/naplo-eafa/kapcsolat/' + this.aktiv.ugyfelId + '/proba', {});
      await this.eafaKapcsBetolt();
      if (r.ok) this.ok(`Az eÁFA ${r.kornyezet === 'teszt' ? 'tesztkörnyezete' : 'éles rendszere'} elfogadta a hitelesítőt.`);
      else {
        this.hiba(`eÁFA: ${r.hiba || r.errorCode || ''} ${r.uzenet || ''}`.trim());
        if (r.magyarazat) this.figyelmeztet(r.magyarazat);
      }
    } catch (e: any) { this.hiba(e?.error?.error || 'A próba nem sikerült.'); }
    finally { this.eafaFut = null; }
  }

  async mentOsa() {
    if (!this.osa.login?.trim() || !this.osa.adoszam?.trim()) return this.hiba('Login és adószám kötelező.');
    try { await this.naplo.put('/osa/beallitas/' + this.aktiv.ugyfelId, this.osa); await this.valt('osa'); await this.eafaKapcsBetolt(); this.ok('NAV-beállítások mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async tesztOsa() {
    this.osaTeszteles = true;
    try { const r: any = await this.naplo.post('/osa/teszt/' + this.aktiv.ugyfelId, {}); this.ok(r?.uzenet || 'Sikeres kapcsolat.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Sikertelen kapcsolat.'); }
    finally { this.osaTeszteles = false; }
  }

  // ---- ROVAT ----
  ujRovat() { this.zarEngedd(); this.szerk = { ugyfel_id: this.aktiv.ugyfelId, rovatszam: '', nev: '', tipus: 'rovat', oszlop: null, afas: false, afa_modosithato: false, alap_afa_kulcs: null, forditott_afa: false }; this.rovatModal.present(); }
  // Alaprovatok betöltése: a hiányzó fő oszlopokat (bevétel 1-2, kiadás 3-7) pótolja. A meglévőket nem
  // duplikálja; pl. ha csak „Bevétel” van, felveszi a kiadás-rovatokat is (így a kiadás-számlák könyvelhetők).
  async alapRovatok() {
    if (!this.aktiv.ugyfelId) return;
    try {
      const r: any = await this.naplo.post('/ugyfel/' + this.aktiv.ugyfelId + '/alapertelmezesek?kieg=1', {});
      await this.valt('rovat');
      this.ok(r?.rovatHozzaadva ? `${r.rovatHozzaadva} alaprovat betöltve.` : 'Minden alaprovat már megvolt.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni az alaprovatokat.'); }
  }
  private rovatAlak(r: any) { return { ...r, afas: !!r.afas, afa_modosithato: !!r.afa_modosithato, forditott_afa: !!r.forditott_afa, alap_afa_kulcs: r.alap_afa_kulcs != null ? Number(r.alap_afa_kulcs) : null, ugyfel_id: this.aktiv.ugyfelId }; }
  szerkRovat(r: any) {
    this.szerk = this.rovatAlak(r); this.rovatModal.present();
    this.zarKer('naplo_rovat', r.id, () => this.szerkUjratolt('rovat', r.id, (x) => this.rovatAlak(x)));
  }
  async mentRovat() {
    if (this.zarTilt) return;
    if (!this.szerk?.rovatszam?.trim() || !this.szerk?.nev?.trim()) return this.hiba('Rovatszám és név kötelező.');
    try {
      if (this.szerk.id) await this.naplo.put('/rovat/' + this.szerk.id, this.szerk);
      else await this.naplo.post('/rovat', this.szerk);
      await this.rovatModal.dismiss(); await this.valt('rovat'); this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  // ---- PARTNER ----
  ujPartner() { this.zarEngedd(); this.szerk = { ugyfel_id: this.aktiv.ugyfelId, nev: '', kata: false, penzforgalmi_afa: false, osszesito_nyilatkozat: false }; this.vies = null; this.partnerModal.present(); }
  private partnerAlak(p: any) { return { ...p, kata: !!p.kata, penzforgalmi_afa: !!p.penzforgalmi_afa, osszesito_nyilatkozat: !!p.osszesito_nyilatkozat, ugyfel_id: this.aktiv.ugyfelId }; }
  szerkPartner(p: any) {
    this.szerk = this.partnerAlak(p); this.vies = null; this.partnerModal.present();
    this.zarKer('naplo_partner', p.id, () => this.szerkUjratolt('partner', p.id, (x) => this.partnerAlak(x)));
  }
  async mentPartner() {
    if (this.zarTilt) return;
    if (!this.szerk?.nev?.trim()) return this.hiba('A név kötelező.');
    try {
      if (this.szerk.id) await this.naplo.put('/partner/' + this.szerk.id, this.szerk);
      else await this.naplo.post('/partner', this.szerk);
      await this.partnerModal.dismiss(); await this.valt('partner'); this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  // ---- GYŰJTŐ ----
  ujGyujto() { this.zarEngedd(); this.szerk = { ugyfel_id: this.aktiv.ugyfelId, kod: '', nev: '' }; this.gyujtoModal.present(); }
  szerkGyujto(g: any) {
    this.szerk = { ...g, ugyfel_id: this.aktiv.ugyfelId }; this.gyujtoModal.present();
    this.zarKer('naplo_gyujto', g.id, () => this.szerkUjratolt('gyujto', g.id, (x) => ({ ...x, ugyfel_id: this.aktiv.ugyfelId })));
  }
  async mentGyujto() {
    if (this.zarTilt) return;
    if (!this.szerk?.kod?.trim() || !this.szerk?.nev?.trim()) return this.hiba('Kód és név kötelező.');
    try {
      if (this.szerk.id) await this.naplo.put('/gyujto/' + this.szerk.id, this.szerk);
      else await this.naplo.post('/gyujto', this.szerk);
      await this.gyujtoModal.dismiss(); await this.valt('gyujto'); this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  // ---- PÉNZTÁR ----
  ujPenztar() { this.zarEngedd(); this.szerk = { ugyfel_id: this.aktiv.ugyfelId, azonosito: '', nev: '', tipus: 'penztar', devizanem: 'HUF', nyito_egyenleg: 0 }; this.penztarModal.present(); }
  szerkPenztar(p: any) {
    this.szerk = { ...p, ugyfel_id: this.aktiv.ugyfelId }; this.penztarModal.present();
    this.zarKer('naplo_penztar', p.id, () => this.szerkUjratolt('penztar', p.id, (x) => ({ ...x, ugyfel_id: this.aktiv.ugyfelId })));
  }
  async mentPenztar() {
    if (this.zarTilt) return;
    if (!this.szerk?.azonosito?.trim() || !this.szerk?.nev?.trim()) return this.hiba('Azonosító és név kötelező.');
    try {
      if (this.szerk.id) await this.naplo.put('/penztar/' + this.szerk.id, this.szerk);
      else await this.naplo.post('/penztar', this.szerk);
      await this.penztarModal.dismiss(); await this.valt('penztar'); this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  // ---- OSZLOP ----
  ujOszlop() {
    const used = this.oszlopok.map(o => o.sorszam);
    const next = [1, 2, 3, 4, 5, 6].find(n => !used.includes(n)) || 1;
    this.szerk = { ugyfel_id: this.aktiv.ugyfelId, sorszam: next, tipus: 'kovetel', fejlec: '', csokkeno_nev: '', csokkeno_rovat: '', novekvo_nev: '', novekvo_rovat: '' };
    this.oszlopModal.present();
  }
  szerkOszlop(o: any) { this.szerk = { ...o, ugyfel_id: this.aktiv.ugyfelId }; this.oszlopModal.present(); }
  async mentOszlop() {
    if (!this.szerk?.sorszam) return this.hiba('A sorszám kötelező.');
    try { await this.naplo.post('/oszlop' + this.naplo.evq(), this.szerk); await this.oszlopModal.dismiss(); await this.valt('oszlop'); this.ok('Mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  async torol(kind: string, item: any) {
    const a = await this.alert.create({
      header: 'Törlés', message: 'Biztosan törli?',
      buttons: [{ text: 'Mégse', role: 'cancel' }, {
        text: 'Törlés', role: 'destructive', handler: async () => {
          try { await this.naplo.del('/' + kind + '/' + item.id); await this.valt(this.nezet); this.ok('Törölve.'); }
          catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
        }
      }],
    });
    a.present();
  }

  tipusCimke(lista: any[], v: any) { return lista.find(x => x.value === v)?.label || v; }
  /** Hosszabb, teendőt megfogalmazó üzenet (a NAV hibakódjához). */
  private async figyelmeztet(m: string) { (await this.toast.create({ message: m, duration: 14000, color: 'warning', position: 'top', buttons: [{ text: 'Rendben', role: 'cancel' }] })).present(); }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1500, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'danger' })).present(); }
}
